"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesDetailsByMonthItem$ = exports.SalesDetailsByMonthItem$outboundSchema = exports.SalesDetailsByMonthItem$inboundSchema = void 0;
exports.salesDetailsByMonthItemToJSON = salesDetailsByMonthItemToJSON;
exports.salesDetailsByMonthItemFromJSON = salesDetailsByMonthItemFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.SalesDetailsByMonthItem$inboundSchema = z.object({
    average_price: z.number().int(),
    count_of_sales: z.number().int(),
    month: z.number().int(),
    year: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_price": "averagePrice",
        "count_of_sales": "countOfSales",
    });
});
/** @internal */
exports.SalesDetailsByMonthItem$outboundSchema = z.object({
    averagePrice: z.number().int(),
    countOfSales: z.number().int(),
    month: z.number().int(),
    year: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averagePrice: "average_price",
        countOfSales: "count_of_sales",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SalesDetailsByMonthItem$;
(function (SalesDetailsByMonthItem$) {
    /** @deprecated use `SalesDetailsByMonthItem$inboundSchema` instead. */
    SalesDetailsByMonthItem$.inboundSchema = exports.SalesDetailsByMonthItem$inboundSchema;
    /** @deprecated use `SalesDetailsByMonthItem$outboundSchema` instead. */
    SalesDetailsByMonthItem$.outboundSchema = exports.SalesDetailsByMonthItem$outboundSchema;
})(SalesDetailsByMonthItem$ || (exports.SalesDetailsByMonthItem$ = SalesDetailsByMonthItem$ = {}));
function salesDetailsByMonthItemToJSON(salesDetailsByMonthItem) {
    return JSON.stringify(exports.SalesDetailsByMonthItem$outboundSchema.parse(salesDetailsByMonthItem));
}
function salesDetailsByMonthItemFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SalesDetailsByMonthItem$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SalesDetailsByMonthItem' from JSON`);
}
//# sourceMappingURL=salesdetailsbymonthitem.js.map